import {urlPrefixed} from '../config';

export const sendInvite = async (email: string) => {
  const resp = await fetch(urlPrefixed('/admin/invite_email'), {
    method: 'POST',
    body: JSON.stringify({email}),
  });
  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }
  return resp;
};
